import React, { Component } from "react";

export default class SupportPage extends Component {
  render() {
    return (
      <div>
        <h1>Hello From Support Page</h1>
      </div>
    );
  }
}
